import React, { useState } from 'react';
import moment from 'moment';

import ImportRow from './ImportRow';
import ImporterTools from './ImporterTools';
import UploadModal from './modals/UploadModal';

const getKey = row => row.customID.length ? row.customID : row.title + row.startDateTime

const Importer = props => {
    const [selectedCsvData, setSelectedCsvData] = useState([])
    const [previousCsvData, setPreviousCsvData] = useState([])
    const [batchCategory, setBatchCategory] = useState('')
    const [batchPrivacy, setBatchPrivacy] = useState(false)
    const [uploadModal, setUploadModal] = useState(false)

    const _toggleUploadModal = () => {
        setUploadModal(!uploadModal)
    }

    const onSubmitCsv = (file) => {
        props.onSubmitCsv(file)
        setUploadModal(false)
    }

    const _updateSelectedCsvs = (csvData) => {
        setSelectedCsvData([...csvData, ...selectedCsvData])
    }

    // do we want to import this row?
    const _handleAssign = (index, evt, val) => {
        props.onAssign(index, evt, val);
    }

    const _handleEncoderAssign = (index, event) => {
        props.onEncoderAssign(index, event.target.value);
    }

    const _handleCategoryAssign = (eventCategoryIndex, event) => {
        props.onCategoryAssign(eventCategoryIndex, event.target.value);
    }

    const handleEstRuntimeChange = (index, value) => {
        props.onEstRuntimeChange(index, value);
    }

    const handleBreakOverrideChange = (index, value) => {
        props.onBreakOverrideChange(index, value);
    }

    const handleBreakOnStartChange = (index, value) => {
        props.onBreakOnStartChange(index, value);
    }

    const _handleLocationAssign = (index, event) => {
        props.onLocationAssign(index, event.target.value);
    }

    const _commitImport = () => {
        setPreviousCsvData([...previousCsvData, ...selectedCsvData])
        setSelectedCsvData([])
        props.onCreateEvents();

    }

    const handleBatchCategoryChange = (event) => {
        var value = event.target.value;
        setBatchCategory(value)
    }

    const handleBatchPrivacyChange = (element, state) => {
        setBatchPrivacy(state)
        props.handleBatchPrivacyChange(state);
    }

    const renderCategoryOptions = (categoryNames) => {
        return categoryNames.map(function (categoryName, i) {
            return (
                <option key={'category-' + categoryName + i} value={categoryName}>
                    {categoryName}
                </option>
            );
        });
    }

    const _renderImportableEventsTable = () => {
        if (props.events.length || props.csvData.length) {

            var rendered = [];
            var csvData = props.csvData || [];

            if (csvData.length) {
                var encoders = props.encoders.data.map(function (encoder, i) {
                    return (
                        <option key={'encoder-' + encoder.encoderID + i} value={encoder.simpleName}>
                            {encoder.simpleName} - ({encoder.online ? 'Online' : 'Offline'})
                        </option>
                    );
                });


                var locations = props.locations.data.map(function (location) {
                    return (
                        <option key={'location-' + location.locationID} value={location.locationName}>
                            {location.locationName}
                        </option>
                    );
                });

                var categoryNames = props.categories.data.map(function (category) {
                    return category.categoryName;
                })
                props.csvData.map(data => {
                    const categoryName = data.category
                    if (categoryNames.indexOf(categoryName) === -1) {
                        categoryNames.push(categoryName)
                    }
                })

                var categories = renderCategoryOptions(categoryNames);
                const { dateFilter } = props;
                csvData.map((event, index) => {

                    var skip = false;

                    if (dateFilter.start !== null && dateFilter.end !== null) {
                        var date = moment(event.startDateTime, 'YYYY-MM-DD HH:mm:ss');
                        if (date < dateFilter.start || date > dateFilter.end) skip = true;
                    }
                    //force format for CRUD the date since its already been validated as a date
                    event.startDateTime = moment(event.startDateTime).format('YYYY-MM-DD HH:mm:ss').toString()
                    if (skip === false) {
                        rendered.push(
                            <ImportRow
                                key={index}
                                event={event}
                                index={index}
                                encoders={encoders}
                                renderedCategories={categories}
                                categoryNames={categoryNames}
                                locations={locations}
                                handleCategoryAssign={_handleCategoryAssign}
                                handleEncoderAssign={_handleEncoderAssign}
                                handleLocationAssign={_handleLocationAssign}
                                handleEstRuntimeChange={handleEstRuntimeChange}
                                handleBreakOverrideChange={handleBreakOverrideChange}
                                handleBreakOnStartChange={handleBreakOnStartChange}
                                handleAssign={_handleAssign}
                                categoryMap={props.categoryMap}
                                encoderMap={props.encoderMap}
                                locationMap={props.locationMap}
                            />
                        );
                    }
                });
            }

            return rendered;
        }

        return <h3 className="text-center">
            Upload CSV File{props.mode == 'special' ?
                ' or Select Date Range to Search' :
                null
            }
        </h3>;
    }

    var errors = <span />;

    if (uploadModal && props.errors.length) {
        errors = (
            <div className="alert alert-danger clearfix" style={{margin: '1em 0'}}>
                {props.errors.map(function (error, index) {
                    return (
                        <div className="col-xs-12" key={'error-' + index}>
                            <i className="fa fa-times"/> {error.message}
                        </div>
                    );
                }, this)}
            </div>
        );
    }

    const renderUnmatchedCategories = () => {
        if (props.categoriesCreated.error) {
            return (<div className="alert alert-danger">
                <h4>Category Creation Error</h4>
                <p>We could not create a Category we found to not exist in your Global Categories.</p>
                <p>This could be a temporary Server issue, so please try the action again.</p>
                <p>If the problem persists, please try the following:</p>
                <ul>
                    <li>Ensure your CSV file has the correct information in the correct order</li>
                    <li>Ensure the Categories in provided to us in your CSV exist by going to the <a href="/manage/categories" target="_blank">Category Management page</a></li>
                    <li>Contact Invintus at <a href="mailto:support@invintus.com"></a> with any questsions</li>
                </ul>
            </div>)
        } else if (props.categoriesCreated.categories.length) {
            return (<div className="alert alert-info">
                <h4>New Categories Created</h4>
                <p>We found a few Categories in your CSV which you had not previously created.</p>
                <p>In order to create the Events you specified, we had to create the following Categories automatically:</p>
                <br/>
                <ul>{props.categoriesCreated.categories.map(
                        (cat, k) => <li key={k}><strong>{cat.categoryName}</strong></li>
                )}</ul>
            </div>)
        }
    }

    return (
        <div id="importer">

            <ImporterTools
                batchToggle={props.batchToggle}
                handleBatchToggleChange={props.handleBatchToggleChange}

                handleBatchCategoryChange={handleBatchCategoryChange}
                batchCategory={batchCategory}
                onBatchCategoryAssignment={props.onBatchCategoryAssignment}

                dateFilter={props.dateFilter}
                handleRangeChanged={props.handleRangeChanged}

                batchPrivacy={props.batchPrivacy}
                handleBatchPrivacyChange={handleBatchPrivacyChange}

                csvData={props.csvData}
                categories={props.categories}

                previousCsvData={props.previousCsvData}
                selectedCsvData={props.selectedCsvData}

                toggleUploadModal={_toggleUploadModal}/>

            {
                // This renders a list of categories which were created if
                // the importer found non-existent categories in the csv
                renderUnmatchedCategories()
            }

            <div className="panel panel-default">

                <div className="listing">
                    {_renderImportableEventsTable()}
                </div>

                <div className="panel-footer text-right">
                    <button id="reset" disabled={!props.csvData.length} className="btn btn-warning" onClick={props.onReset}>
                        <i className="fa fa-undo"/> Reset
                    </button>
                    <button id="import" disabled={!props.csvData.length} className="btn btn-primary" onClick={_commitImport}>
                        <i className="fa fa-download"/> Import
                    </button>
                </div>
            </div>

            {uploadModal ?
                <UploadModal
                    onSubmitCsv={onSubmitCsv}
                    previousCsvData={props.csvData}
                    toggleModal={_toggleUploadModal}/> :
                null
            }

        </div>
    );

}

export default Importer;
